import { GetAsync } from "common/httpRequests";
import { BACKEND } from "constants/settings";
import { createContext, useEffect, useState } from "react";
import { loginSupplierAction } from "redux/slices/supplier";
import { store } from "redux/store";

type AuthContextProps = {
  allowed: boolean | "";
  isLoading: boolean;
  customLogo: {
    hasCustomLogo: boolean;
    isLoadingCustomLogo: boolean;
  };
  isSupplierDocumentExpired: boolean;
  fetchSupplierData: (silent?: boolean) => Promise<any>;
};

const AuthContext = createContext<AuthContextProps | null>(null);
const AuthProvider: React.FC<{ children }> = ({ children }) => {
  const [allowed, setAllowed] = useState<boolean | "">("");

  const [customLogo, setCustomLogo] = useState({
    hasCustomLogo: false,
    isLoadingCustomLogo: false,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSupplierDocumentExpired, setIsSupplierDocumentExpired] =
    useState(false);
  const currentSupplierId = window.location.pathname.split("/")[1];

  const fetchSupplierData = async (silent = false) => {
    if (!silent) setIsLoading(true);
    try {
      if (currentSupplierId) {
        const response = await GetAsync(
          `${BACKEND}/api/vendorservice/Suppliers/${currentSupplierId}`,
        );
        if ([201, 200, 204].includes(response.status)) {
          store.dispatch(loginSupplierAction(response.data));
          setAllowed(true);
          setIsSupplierDocumentExpired(response.data.isSupplierDocumentExpired);

          return response.data;
        } else {
          setAllowed(false);
        }
      } else {
        setAllowed(false);
      }
    } finally {
      if (!silent) setIsLoading(false);
    }
  };

  const getSupplierCustomLogo = () => {
    setCustomLogo({ ...customLogo, isLoadingCustomLogo: true });
    GetAsync(
      `${BACKEND}/api/vendorservice/suppliers/customLogo/${currentSupplierId}`,
    ).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          setCustomLogo({ hasCustomLogo: true, isLoadingCustomLogo: false });
        }
      } else {
        setCustomLogo({ hasCustomLogo: false, isLoadingCustomLogo: false });
      }
    });
  };

  useEffect(() => {
    const fetchAPIs = async () => {
      await fetchSupplierData();
    };

    fetchAPIs();
    if (!customLogo.hasCustomLogo) {
      getSupplierCustomLogo();
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        allowed,
        isLoading,
        customLogo,
        isSupplierDocumentExpired,
        fetchSupplierData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
